import api from '@/api';

import {
  CustomerContact,
  CreateCustomerContactRequest,
  DataContact,
} from './CustomerContacts.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/customers`;

export async function listCustomerContacts(customerId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${customerId}/contacts`,
    null,
  )) as unknown;

  return result as DataContact;
}

export async function createCustomerContact(data: {
  value: CreateCustomerContactRequest;
  customerId: number;
}) {
  const result = (await api.post(
    `${CONTROLLER_URL}/${data.customerId}/contacts`,
    data.value,
    null,
  )) as unknown;

  return result as CustomerContact;
}

export async function updateCustomerContact(
  data: CreateCustomerContactRequest & { customerId: number; id: number },
) {
  const { customerId, id, ...obj } = data;
  const result = (await api.put(
    `${CONTROLLER_URL}/${customerId}/contacts/${id}`,
    obj,
    null,
  )) as unknown;

  return result as CustomerContact;
}

export async function deleteCustomerContact(
  customerId: number,
  contactId: number,
) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${customerId}/contacts/${contactId}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function removeCustomerContactDetail(
  customerId: number,
  detailId: number,
) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${customerId}/contacts/contactDetail/${detailId}`,
    {},
    null,
  )) as unknown;

  return result as void;
}
